import react, {useEffect,useState} from 'react';
import style from './style.module.css';


const Footer: React.FC = () => {

    const dateYear = process.env.REACT_APP_YEAR;
    const disclaimer = process.env.REACT_APP_DISCLAIMER;
    const version = process.env.REACT_APP_VERSION;

    return (<>

                    <div className={style.footer}>
                        <div className={style.column}>
                            <div className={style.footerLogo}>
                                <div className={style.appMenuIcon}></div>
                            </div><div className={style.disclaimer}>
                                &copy; {dateYear} {disclaimer} &nbsp;&nbsp;&bull;&nbsp;&nbsp; {version}
                            </div>
                        </div>
                    </div>
    </>)

}

export default Footer;